import React from "react";
import ComputerScienceHeader from "../components/Courses/ComputerScience/ComputerScienceHeader";
import ComputerScienceCareerSkills from "../components/Courses/ComputerScience/ComputerScienceCareerSkills";
import ComputerScienceProgramsCard from "../components/Courses/ComputerScience/ExploreProgramsComputerScience";
import ComputerScienceAdmissionRequirements from "../components/Courses/ComputerScience/ComputerScienceAdmissionRequirements";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";

const ComputerScience = () => {
  return (
    <div>
      <Navbar />
      <ComputerScienceHeader />
      <ComputerScienceCareerSkills />
      <ComputerScienceProgramsCard />
      <ComputerScienceAdmissionRequirements />
      <FullScreenImage />
      <Footer />
    </div>
  );
};

export default ComputerScience;
